import React from 'react';
import { BrandPageScreen } from '@/screens/brand-page/brand-page-screen';
import { CatalogScanner } from '@/components/scanner/catalog-scanner';
import { createStackNavigator } from '@react-navigation/stack';
import { CreditRequestScanScreen } from '@/screens/partners/credit-request-scan-screen';
import { EditOrderGuideStack } from './edit-order-guide-stack';
import { MultiOrderGuideScreen } from '@/screens/partners/multi-order-guide-screen';
import { ORDER_GUIDE_ROUTES } from '@/navigators/routes';
import { OrderGuideStackParams } from '@/navigators/types';
import { OrderGuideUnifiedSearchScreen } from '@/screens/partners/unified-search-screen';
import { OrderGuideVolumePromotionsListScreen } from '@/screens/partners/order-guide-volume-promotions-list-screen';
import { TagPrintBatchScreen } from '@/screens/partners/tag-print-batch-screen';
import { useCatalogGroupItemsLoader } from '@/hooks/use-catalog-group-items-loader';
import { useDefaultAppTabScreenOptions } from '@/hooks/use-default-app-tab-screen-options';
import { useFullScreenOptions } from '@/hooks/use-full-screen-options';
import { useNewOrderContext } from '@/contexts/new-order-context';
import { VolumePromotionDetailScreen } from '@/screens/partners/volume-promotion-detail-screen';

const Stack = createStackNavigator<OrderGuideStackParams>();

export const OrderGuideStack: React.FC = () => {
  const screenOptions = useDefaultAppTabScreenOptions();
  const fullScreenOptions = useFullScreenOptions();
  const { customOrderGuideEditingEnabled } = useNewOrderContext();

  // Iniitalize the loader for carousels rendered in unified search
  useCatalogGroupItemsLoader();

  return (
    <Stack.Navigator screenOptions={screenOptions}>
      <Stack.Screen
        component={MultiOrderGuideScreen}
        name={ORDER_GUIDE_ROUTES.Base}
      />
      <Stack.Screen
        component={OrderGuideUnifiedSearchScreen}
        name={ORDER_GUIDE_ROUTES.OrderGuideUnifiedSearch}
      />
      <Stack.Screen component={CatalogScanner} name={ORDER_GUIDE_ROUTES.Scan} />
      {customOrderGuideEditingEnabled ? (
        <Stack.Screen
          component={EditOrderGuideStack}
          name={ORDER_GUIDE_ROUTES.Edit}
          options={fullScreenOptions}
        />
      ) : null}
      <Stack.Screen
        component={CreditRequestScanScreen}
        name={ORDER_GUIDE_ROUTES.CreditRequestScan}
      />
      <Stack.Screen
        component={OrderGuideVolumePromotionsListScreen}
        name={ORDER_GUIDE_ROUTES.VolumePromotionsList}
      />
      <Stack.Screen
        component={VolumePromotionDetailScreen}
        name={ORDER_GUIDE_ROUTES.VolumePromotionDetail}
      />
      <Stack.Screen
        component={BrandPageScreen}
        name={ORDER_GUIDE_ROUTES.BrandPage}
      />
      <Stack.Screen
        component={TagPrintBatchScreen}
        name={ORDER_GUIDE_ROUTES.TagPrintBatch}
      />
    </Stack.Navigator>
  );
};
